import { AuthStorage } from "utils/auth-storage";
import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveReportAccessLevel } from "redux/permission-reducer";

import { WarehouseServices } from "apis/Services/WarehouseService";

import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";

import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import styles from "./warehouse-jobSites.module.css";

import {
  Button,
  Tag,
  Card,
  Empty,
  Tooltip,
  Input,
  Dropdown,
  Modal,
  Form,
  Select,
  message,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  MoreOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import LoadingComponent from "components/loading-component";

import toast from "react-hot-toast";
import ItemsShippedModal from "pages/project-details/items-shipped-modal";

const { Option } = Select;

export default function WarehouseJobSites() {
  const { company_id, id } = useParams();
  const [isLoading, setisLoading] = useState(true);
  const [accessLevel, setAccessLevel] = useState();
  const [data, setData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [form] = Form.useForm();

  const [itemsShippedData, setItemsShippedData] = useState([]);
  const [itemsShippedModal, setItemsShippedModal] = useState(false);
  const [itemsShippedHistoryData, setItemsShippedHistoryData] = useState([]);
  const [isitemsShippedLoading, setIsitemsShippedLoading] = useState(true);
  const [selectedJobSiteID, setSelectedJobSiteID] = useState("");

  const [subLocations, setSubLocations] = useState([]);
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);

  const handleCloseSubLocation = (removedTag) => {
    const newTags = subLocations.filter((tag) => tag !== removedTag);
    setSubLocations(newTags);
    form.setFieldsValue({ subLocations: newTags });
  };

  const showSubLocationInput = () => {
    setInputVisible(true);
  };

  const handleSubLocationInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleSubLocationInputConfirm = () => {
    if (inputValue && !subLocations.includes(inputValue)) {
      const newTags = [...subLocations, inputValue];
      setSubLocations(newTags);
      form.setFieldsValue({ subLocations: newTags });
    }
    setInputVisible(false);
    setInputValue("");
  };

  useEffect(() => {
    if (inputVisible) {
      inputRef.current?.focus();
    }
  }, [inputVisible]);

  const tagPlusStyle = {
    background: "#fff",
    borderStyle: "dashed",
    cursor: "pointer",
  };

  const transfersToProjectInventoryHistory = () => {
    setIsitemsShippedLoading(true);

    let company_id = AuthStorage.getItem("company_id");
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    const data = {
      company: company_id,
      projectID: selectedJobSiteID,
      code: code,
      email: email,
    };
    WarehouseServices.transfersToProjectInventoryHistory(data)
      .then((res) => {
        setItemsShippedData(res.inProcessingTransfers);
        setItemsShippedHistoryData(res.completedTransfers);
        // console.log(res, "NEW DATAAA");
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setIsitemsShippedLoading(false));
  };

  const dispatch = useDispatch();

  // Filter data based on search text
  const filteredData = data.filter((item) => {
    if (!searchText) return true;

    const searchLower = searchText.toLowerCase();

    return (
      (item.name && item.name.toLowerCase().includes(searchLower)) ||
      (item.address && item.address.toLowerCase().includes(searchLower)) ||
      (item.status && item.status.toLowerCase().includes(searchLower)) ||
      (item.type && item.type.toLowerCase().includes(searchLower))
    );
  });

  function getAccessLevel() {
    setisLoading(true);
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      project: id,
      code,
      loginEmail: email,
    };
    WarehouseServices.inventoryPageAccessLevel(ReqObj)
      .then((res) => {
        setAccessLevel(parseInt(res.accessLevel));
        if (parseInt(res?.accessLevel) > 0) {
          // getData()
        } else {
          setisLoading(false);
        }
        dispatch(saveReportAccessLevel(res.accessLevel));
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getData() {
    // setisLoading(true);
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      code,
      loginEmail: email,
    };
    WarehouseServices.getJobSites(ReqObj)
      .then((res) => {
        setData(res);
        // console.log(data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setisLoading(false));
  }

  // Handle adding new job site
  const handleAddJobSite = () => {
    setIsEditing(false);
    setSelectedItem(null);
    setIsModalVisible(true);
    form.resetFields();
    setSubLocations([]);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    setIsEditing(false);
    setSelectedItem(null);
    form.resetFields();
    setSubLocations([]); // **NEW: Reset subLocations state on cancel**
  };

  const handleModalSubmit = async (values) => {
    setIsSubmitting(true);

    try {
      const code = AuthStorage.getItem("token");
      const email = AuthStorage.getItem("email");

      const requestData = {
        ...values,
        subLocations: values.subLocations || [],
        source: "Koncurent",
        company: company_id,
        code,
        loginEmail: email,
      };

      if (isEditing && selectedItem) {
        requestData.jobSiteID = selectedItem.jobSiteID;

        let code = AuthStorage.getItem("token");
        let email = AuthStorage.getItem("email");
        let ReqObj = {
          company: company_id,
          code,
          loginEmail: email,
          requestData,
        };
        WarehouseServices.updateJobSite(ReqObj)
          .then((res) => {
            getData();
            toast.success("Job site updated successfully");
            // getData();
          })
          .catch((err) => {
            console.log(err);
            toast.error("Something went wrong, please try again.");
          });
      } else {
        // Create new job site

        let code = AuthStorage.getItem("token");
        let email = AuthStorage.getItem("email");
        let ReqObj = {
          company: company_id,
          code,
          loginEmail: email,
          requestData,
        };
        WarehouseServices.createJobSite(ReqObj)
          .then((res) => {
            getData();
            toast.success("Job site created successfully");
            // getData();
          })
          .catch((err) => {
            console.log(err);
            toast.error("Something went wrong, please try again.");
          });
      }

      setIsModalVisible(false);
      setIsEditing(false);
      setSelectedItem(null);
      form.resetFields();
      setSubLocations([]);

      // Refresh the data
      getData();
    } catch (error) {
      console.error("Error saving job site:", error);
      message.error(
        `Failed to ${
          isEditing ? "update" : "create"
        } job site. Please try again.`
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // Helper function to get status tag color
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "active":
        return "green";
      case "expired":
        return "red";
      case "inactive":
        return "#D3D3D3";
      default:
        return "default";
    }
  };

  useEffect(() => {
    getAccessLevel();
    getData();
  }, []);

  const handleEdit = (record) => {
    setSelectedItem(record);
    setIsEditing(true);
    setIsModalVisible(true);

    // Set subLocations state and pre-fill form
    const currentSubLocations = record?.subLocationNames || [];
    setSubLocations(currentSubLocations);

    form.setFieldsValue({
      name: record.name,
      status: record.status,
      type: record.type,
      address: record.address,
      // Add subLocations to the form fields value
      subLocations: currentSubLocations,
    });
  };
  const handleDelete = (record) => {
    Modal.confirm({
      title: "Are you sure you want to delete this job site?",
      content: `${record.name || "This job site"} will be permanently deleted.`,
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk: async () => {
        try {
          const code = AuthStorage.getItem("token");
          const email = AuthStorage.getItem("email");

          const requestData = {
            jobSiteID: record.jobSiteID,
            company: company_id,
            code,
            loginEmail: email,
          };

          await WarehouseServices.deleteJobSite(requestData);
          getData();
          toast.success("Job site deleted successfully");
        } catch (error) {
          console.error("Error deleting job site:", error);
          message.error("Failed to delete job site. Please try again.");
        }
      },
    });
  };

  const getDropdownItems = (record) => ({
    items: [
      {
        key: "edit",
        icon: <EditOutlined />,
        label: "Edit",
        onClick: (e) => {
          e.domEvent.stopPropagation();
          handleEdit(record);
        },
      },
      // Only show delete option if source is not Procore
      ...(record.source !== "Procore"
        ? [
            {
              key: "delete",
              icon: <DeleteOutlined />,
              label: "Delete",
              danger: true,
              disabled: accessLevel === 2,
              onClick: (e) => {
                e.domEvent.stopPropagation();
                handleDelete(record);
              },
            },
          ]
        : []),
    ],
  });

  const isProcoreJobSite = isEditing && selectedItem?.source === "Procore";

  return (
    <div className="bg-white p-4 rounded-3 d-flex justify-content-center">
      {isLoading && (
        <div className="row d-flex justify-content-center">
          <LoadingComponent />
        </div>
      )}

      {!isLoading && accessLevel === 0 && (
        <div className="row w-100 d-flex justify-content-center p-5">
          {!isLoading && accessLevel === 0 && (
            <div className="row w-100 d-flex justify-content-center p-5">
              <div className="d-flex flex-column align-items-center text-center gap-3">
                <LockRoundedIcon style={{ fontSize: "5rem", color: "#999" }} />
                <h6 className="mt-2 mb-0 text-muted">
                  You do not have the necessary permissions to access this page.
                </h6>
              </div>
            </div>
          )}
        </div>
      )}

      {!isLoading && accessLevel > 0 && (
        <div style={{ width: "85%" }}>
          <div className="d-flex justify-content-between align-items-center">
            <div className=" ">
              <h3 className="fw-bold p-0 m-0">Job Sites</h3>
              <p className="opacity-75 mt-2 p-0">
                Manage construction sites and track material allocations
              </p>
            </div>

            {/* <Button type="primary">+ Add Job Site</Button> */}
          </div>

          <div className=" my-2">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4">
              {/* Filter Buttons */}
              <div className="d-flex gap-2 flex-wrap">
                <Input
                  placeholder="Search Job Sites, location, status..."
                  prefix={<SearchOutlined />}
                  style={{ width: "300px" }}
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  allowClear
                />
              </div>

              <Button
                type="primary"
                size="large"
                onClick={handleAddJobSite}
                disabled={accessLevel < 2}
              >
                <PlusOutlined /> Add Job Site
              </Button>
            </div>

            {/* Show search results count */}
            {searchText && (
              <div className="mb-3">
                <p className="text-muted small">
                  {filteredData.length} of {data.length} job sites match "
                  {searchText}"
                </p>
              </div>
            )}

            {/* Show Empty component when no data or no search results */}
            {filteredData.length === 0 ? (
              <div className="d-flex justify-content-center w-100 my-5">
                <Empty
                  image={
                    <LocationOnOutlinedIcon
                      style={{ fontSize: "4rem", color: "#d9d9d9" }}
                    />
                  }
                  imageStyle={{
                    height: 80,
                    marginBottom: 16,
                  }}
                  description={
                    <div>
                      <p
                        className="mb-1"
                        style={{ fontSize: "1rem", fontWeight: "500" }}
                      >
                        {searchText
                          ? `No job sites found matching "${searchText}"`
                          : "No job sites found"}
                      </p>
                    </div>
                  }
                ></Empty>
              </div>
            ) : (
              // Show project cards when data is available
              <div className={`${styles.jobsitesGrid}`}>
                {filteredData.map((item) => (
                  <Tooltip title="View Warehouse Transfers History">
                    <Card
                      className={`bg-light bg-opacity-75 ${styles.hoverCard}`}
                      key={item.jobSiteID}
                      onClick={() => {
                        setItemsShippedModal(true);
                        setSelectedJobSiteID(item.jobSiteID);
                      }}
                      title={
                        <div className=" d-flex flex-column gap-0 p-2">
                          <div className="d-flex flex-wrap justify-content-between align-items-center">
                            <div className="d-flex gap-0 align-items-center">
                              <Tooltip title={item.source}>
                                <div
                                  className="me-2"
                                  style={{
                                    width: "4px",
                                    height: "25px",
                                    backgroundColor:
                                      item.source === "Koncurent"
                                        ? "#1890ff"
                                        : "#ff7a00",
                                    // borderRadius: "2px",
                                  }}
                                ></div>
                              </Tooltip>
                              <h5
                                className="text-truncate pt-2"
                                title={item["Project Name"]}
                              >
                                {item.name}
                              </h5>
                            </div>

                            <div>
                              {/* {item.source === "Koncurent" && ( */}
                              <Dropdown
                                menu={getDropdownItems(item)}
                                trigger={["click"]}
                                disabled={accessLevel < 2}
                              >
                                <Button
                                  type="text"
                                  shape="circle"
                                  icon={<MoreOutlined />}
                                  onClick={(e) => e.stopPropagation()}
                                />
                              </Dropdown>
                              {/* )} */}
                            </div>
                          </div>
                          <div>
                            <Tag
                              color={getStatusColor(item.status)}
                              className=" rounded-5 fw-bold"
                              bordered={false}
                            >
                              {item.status}
                            </Tag>
                          </div>
                        </div>
                      }
                      size="small"
                    >
                      <div className="d-flex flex-column gap-3  ">
                        <div className=" d-flex flex-column gap-3 my-2">
                          <div>
                            <div className="d-flex align-items-center mb-1">
                              <AccountBalanceIcon
                                className=" opacity-75"
                                style={{
                                  fontSize: "1.2rem",
                                  // color: "#666",
                                  marginRight: "8px",
                                }}
                              />
                              <p className="mb-0 text-muted ">
                                {item.type || "No type specified"}
                              </p>
                            </div>
                          </div>

                          <div>
                            <div className="d-flex align-items-start">
                              <LocationOnOutlinedIcon
                                className=" opacity-75"
                                style={{
                                  fontSize: "1.2rem",
                                  // color: "#666",
                                  marginRight: "8px",
                                  marginTop: "2px",
                                }}
                              />
                              <p className="mb-0 text-muted ">
                                {item.address.length > 0
                                  ? item.address
                                  : "Address not provided"}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="mt-auto pt-2 border-top">
                          <div className="d-flex align-items-center justify-content-between">
                            <div>
                              <p
                                className="mb-0 text-muted"
                                style={{ fontSize: "12px" }}
                              >
                                Created at: {item.createdAt.split(" ")[0]}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </Tooltip>
                ))}
              </div>
            )}
          </div>

          {/* Add Job Site Modal */}
          <Modal
            title={isEditing ? "Edit Job Site" : "Add New Job Site"}
            open={isModalVisible}
            centered
            onCancel={handleModalCancel}
            footer={null}
            // width={600}
          >
            <Form
              form={form}
              layout="vertical"
              onFinish={handleModalSubmit}
              requiredMark={false}
            >
              {isProcoreJobSite && (
                <div className="mb-3 p-2 bg-light border rounded">
                  <p className="mb-0 text-muted small">
                    <strong>Note:</strong> This job site is synced from Procore.
                    Only sub-locations can be modified.
                  </p>
                </div>
              )}

              <Form.Item
                label="Job Site Name"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Please enter the job site name",
                  },
                ]}
              >
                <Input
                  placeholder="Enter job site name"
                  disabled={isProcoreJobSite}
                />
              </Form.Item>

              <Form.Item
                label="Status"
                name="status"
                rules={[
                  {
                    required: true,
                    message: "Please select a status",
                  },
                ]}
              >
                <Select placeholder="Select status" disabled={isProcoreJobSite}>
                  <Option value="Active">Active</Option>
                  <Option value="Inactive">Inactive</Option>
                  <Option value="Expired">Expired</Option>
                </Select>
              </Form.Item>

              <Form.Item
                label="Type"
                name="type"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please enter the job site type",
                //   },
                // ]}
              >
                <Input
                  placeholder="Enter job site type (e.g., Residential, Commercial)"
                  disabled={isProcoreJobSite}
                />
              </Form.Item>

              <Form.Item
                label="Address"
                name="address"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please enter the address",
                //   },
                // ]}
              >
                <Input
                  placeholder="Enter address"
                  disabled={isProcoreJobSite}
                />
              </Form.Item>

              <Form.Item
                label="Sub-Locations"
                name="subLocations"
                initialValue={subLocations}
              >
                <div>
                  <div style={{ marginBottom: 8 }}>
                    {subLocations.map((tag) => (
                      <span
                        key={tag}
                        style={{
                          display: "inline-block",
                          marginRight: 8,
                          marginBottom: 8,
                        }}
                      >
                        <Tag
                          closable
                          className="rounded"
                          onClose={(e) => {
                            e.preventDefault();
                            handleCloseSubLocation(tag);
                          }}
                          style={{
                            fontSize: "14px",
                            padding: "5px 10px",
                            height: "auto",
                          }}
                        >
                          {tag}
                        </Tag>
                      </span>
                    ))}
                  </div>
                  {inputVisible ? (
                    <Input
                      ref={inputRef}
                      type="text"
                      size="default"
                      style={{ width: 150 }}
                      placeholder="SubLocation Name"
                      value={inputValue}
                      onChange={handleSubLocationInputChange}
                      onBlur={handleSubLocationInputConfirm}
                      onPressEnter={handleSubLocationInputConfirm}
                    />
                  ) : (
                    <Tag
                      onClick={showSubLocationInput}
                      style={{
                        ...tagPlusStyle,
                        fontSize: "14px",
                        padding: "5px 10px",
                        height: "auto",
                      }}
                    >
                      <PlusOutlined /> Add Sub-Location
                    </Tag>
                  )}
                </div>
              </Form.Item>

              <div className="d-flex justify-content-end gap-2 mt-4">
                <Button onClick={handleModalCancel}>Cancel</Button>
                <Button type="primary" htmlType="submit" loading={isSubmitting}>
                  {isEditing ? "Update Job Site" : "Create Job Site"}
                </Button>
              </div>
            </Form>
          </Modal>
        </div>
      )}

      <ItemsShippedModal
        itemsShippedData={itemsShippedData}
        itemsShippedModal={itemsShippedModal}
        isitemsShippedLoading={isitemsShippedLoading}
        transfersToProjectInventoryHistory={transfersToProjectInventoryHistory}
        itemsShippedHistoryData={itemsShippedHistoryData}
        setItemsShippedModal={setItemsShippedModal}
        projectID={id}
        accessLevel={accessLevel}
        // projectDetails={projectDetails}
        // editedItems={editedItems}
      />
    </div>
  );
}
